import config from '@/config'
import session from '@/common/js/session'
import axios from 'axios'
import sys from '@/common/js/sys'
import qs from 'qs'
import router from '../../router'
// axios默认配置
axios.defaults.timeout = 70000;   // 超时时间
//axios.defaults.baseURL = config.apiPath; // 默认地址
axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'; //不走预请求  低级请求

// 路由请求拦截
// http request 拦截器
axios.interceptors.request.use(
  config => {
    return config;
  },
  error => {
    return Promise.reject(error.response);
  });

// 路由响应拦截
// http response 拦截器
axios.interceptors.response.use(
  response => {
      sys.loading.hide();
      if(response){
        //if(response.data){
            let result = response.data;
            result=result||{success:true};
            if (result && result.sessionstatus == 'no_authority') {
                sys.dialog.alert(result.sessionstatusMsg);
                result.success = false;
                return;
            } else if (result && result.sessionstatus == 'timeout') {
                sys.dialog.errormsg("没登陆系统或登录超时，请登录系统");
                session.removeUser();
                router.push('/login');
                result.success = false;
                return;
            }
            if (config.defaultMsg != false ) {
                switch (result.type) {
                    case "error" :
                        sys.dialog.error(result.msg);
                        result.success = false;
                        break;
                    case "info" :
                        sys.dialog.msg(result.msg);
                        result.success = false;
                        break;
                    case "ok" :
                        sys.dialog.success(result.msg);
                        result.success = true;
                        break;
                    default :
                        //返回值为空通用提示 操作成功
                        break;
                }
            }
            return result;
       // }
      }
  },
  error => {
        sys.loading.hide();
        if('Network Error'==error.message+''){
            sys.dialog.error('请求错误-'+error.message);
        }
  });


const request = {
    post: function (url, data,configParam) {
        configParam=configParam||{};

        if(url.indexOf('query')>-1 || url.indexOf('find')>-1|| url.indexOf('is')>-1){
            configParam.loading = false;
        }

        if( configParam.loading!=false){
            sys.loading.show();
        }

        let dataConfig = {
            url: config.apiPath+url,
            method: 'post',
            headers:{
                isajax:'true',
                token:session.getToken()
            }
        };
        /* let param = new URLSearchParams();
        if (data) {
            for (var key in data) {
                param.append(key, data[key])
            }
        }  */
        dataConfig.data = qs.stringify(data);
        return axios(dataConfig);
    },
    isSuccess:function(data){
        return data && data.success;
    }
}
export default request



// WEBPACK FOOTER //
// ./src/common/js/request.js